import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

// Types
import { CheckActivationCodeValidityAndTrialMode, UseActivationCodeResponse } from '../../../shared/types/manageCalls';

// Services
import { WebServiceCaller } from '../../services/webservice-caller/webservice-caller.service';

@Injectable()
export class ActivationCodeService {
  private wsCaller = inject(WebServiceCaller);


  public useActivationCode(activationCode: string): Observable<UseActivationCodeResponse> {
    return this.wsCaller.postCall('useActivationCode', { activationCode });
  }

  public checkActivationCodeValidity(): Observable<CheckActivationCodeValidityAndTrialMode> {
    return this.wsCaller.postCall('checkActivationCodeValidity');
  }
}
